import { Button, HStack, Icon, IconButton, Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import { ICIKK } from "@coimbra-its/api.konyvelo";
import { CellProps, useDebounce, useWSysLocalFilter, useWSysPage, useWSysPath, WSysHeaderButton, WSysPage, WSysSearch, WSysTable, WSysVert } from "@coimbra-its/websys-ux-core";
import { useEffect, useState } from "react";
import { APPICONS } from "../Icons";
import { useKonyveloApi } from "../store/konyvelo.api";
import { useParams, useSearchParams } from "react-router-dom";


export const CELLS: CellProps<ICIKK>[] = [
    { 'title': 'Kód', elem: (row) => row.CIKK_KOD, charWidth: 10 },
    { 'title': 'Megnevezés', elem: (row) => row.NEV, charWidth: 30 },
];

export function CikkList({ onSelect, onClosed }: { onSelect: (cikk: ICIKK|undefined) => void, onClosed: () => void }) {

    useWSysPath();
    const page = useWSysPage({ title: 'Cikklista', maxCols: 2, variant: 'popup', onClosed });
    const searchParams = useSearchParams();
    const path = useWSysPath();
    const [q, setQ] = path.useParam('q');



    const api = useKonyveloApi();
    const [data, hub] = api.cikkGet.useData({ q });

    const cikkList = data?.cikkList || [];


    return <WSysPage page={page} hubs={[hub]}
        tools={
            <HStack>
                <WSysSearch name="q" />
                <IconButton size='sm' colorScheme="red" aria-label="cikk törlés" icon={<APPICONS.DeleteRow/>} onClick={() => onSelect(undefined)} />
            </HStack>
        }
    >
        <WSysVert mode="rest">
            <WSysTable
                rows={cikkList}
                cells={CELLS}
                onRowSelect={onSelect}
                noHead={true}
            >

            </WSysTable>
        </WSysVert>
    </WSysPage>
}